import React from 'react';
import { connect } from 'react-redux';

import { ERROR } from 'constants/error-severities';
import { SHARE_VIDEO_PRIVACY_UPDATED } from 'constants/events';
import { updateVideoSettings } from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';

import Button from 'components/ui-components/button';
import Input from 'components/ui-components/input';

import './styles.less';

class PrivacySettings extends React.Component {
  static defaultProps = {
    onCancelClick: () => {},
    onSaveClick: () => {},
  };

  state = {
    password: null,
    confirmPassword: null,
    error: null,
  };

  render() {
    const { video, validationError, onCancelClick } = this.props;

    if (video == null) {
      return null;
    }

    const { password, confirmPassword, error } = this.state;

    const passError = validationError || error;
    const passErrSeverity = passError ? ERROR : '';

    return (
      <div className="edit-privacy-settings">
        <div className="edit-privacy-settings-header">Password Protect</div>
        <Input
          autoFocus={true}
          fieldValue={password}
          fieldLabel="Enter new password"
          fieldType="password"
          inputClass="new-style"
          status={validationError}
          severity={passErrSeverity}
          onChange={this.handleUpdatePassword}
          onEnter={this.handleSaveClick}
        />
        <Input
          autoFocus={false}
          fieldValue={confirmPassword}
          fieldLabel="Confirm password"
          fieldType="password"
          inputClass="new-style"
          status={passError}
          severity={passErrSeverity}
          onChange={this.handleUpdateConfirmPassword}
          onEnter={this.handleSaveClick}
        />
        {video.is_protected && (
          <div
            className="remove-password-button"
            onClick={this.handleRemovePasswordClick}
          >
            Remove password
          </div>
        )}
        <div className="video-settings-buttons">
          <Button
            outerClass={'video-settings-cancel'}
            buttonType="rp-secondary-3"
            value="Cancel"
            onClicked={onCancelClick}
          />
          <Button
            outerClass={'video-settings-save'}
            buttonType="rp-primary-3"
            value="Save"
            onClicked={this.handleSaveClick}
          />
        </div>
      </div>
    );
  }

  handleUpdateConfirmPassword = confirmPassword => {
    this.setState({ confirmPassword });
  };

  handleUpdatePassword = password => {
    this.setState({ password });
  };

  handleRemovePasswordClick = () => {
    const { video, updateVideoSettings, onSaveClick } = this.props;

    analytics.track(SHARE_VIDEO_PRIVACY_UPDATED, {
      action: 'removed',
      video_id: video.id,
    });

    updateVideoSettings({}, null);
    onSaveClick();
  };

  handleSaveClick = () => {
    const { password, confirmPassword } = this.state;
    const { onSaveClick, video, updateVideoSettings } = this.props;

    if (password !== confirmPassword) {
      this.setState({ error: 'The passwords do not match.' });

      return;
    }

    let pwd; // default to not changing password setting

    if ((password || '').length > 0) {
      // Only change password if user entered a new one (ie. length > 0)
      pwd = password;
    }

    if (pwd !== undefined) {
      analytics.track(SHARE_VIDEO_PRIVACY_UPDATED, {
        action:
          !video.is_protected && (password || '').length > 0
            ? 'added'
            : 'changed',
        video_id: video.id,
      });

      updateVideoSettings({}, pwd);
    }

    onSaveClick();
  };
}

const mapStateToProps = state => {
  const {
    settings_modal_err: validationError,
    show_pw_settings_modal: show,
    video,
  } = state.share_video;

  return {
    show,
    validationError,
    video,
  };
};

const mapDispatchToProps = dispatch => ({
  updateVideoSettings: (newSettings, password) =>
    dispatch(updateVideoSettings(newSettings, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivacySettings);
